import logger from '@goldcast/logger';

import analytics from '@/analytics';
import router from '@/router';
import store from '@/store';
import { Toast } from '@/store/modules/studioToast';

type extraOptions = {
  clipId?: string;
  showHeaderActions?: boolean;
  postId?: string;
  renderOnlyContent?: boolean;
  showStudioActionBar?: boolean;
};

export default function renderReactComponent(
  renderer,
  id,
  options: extraOptions = {},
  callbacks: Record<string, (...args: any[]) => any> = {}
) {
  // Pass store to the React component to access the vue store
  return renderer(id, {
    ...store,
    logger,
    analytics,
    adminAppRouter: router,
    options,
    callbacks,
    triggerAdminAppToast: (options: Partial<Toast>) => {
      return store.dispatch('studioToast/triggerToast', {
        msg: options.msg,
        mode: options.mode,
        duration: options.duration,
        action: options.action
      });
    }
  });
}
